<template>
  <lazy-div :load="doInit">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs4>
              <div class="headline">Package Plan</div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs4>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <v-btn color="secondary" class="white--text" slot="activator">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                      </template>
                      <template v-else>
                        No column found
                      </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-data-table v-bind:headers="listHeaders" v-bind:items="items" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText">
              <template slot="items" slot-scope="props">
                <td v-for="column in selectedColumns" :key="column">
                  {{props.item[column]}}
                </td>
                <td class="text-xs-right">
                  <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
                </td>
              </template>
            </v-data-table>
            <v-btn color="primary" dark class="mb-2" @click="doNew">New Plan<v-icon>mdi-plus</v-icon></v-btn>
            <confirm v-model="promptRemove" @ok="doRemove">
              Are you sure that you want to delete the selected Plan?
              <div class="title">{{deletePlan}}</div>
            </confirm>
        </v-card>
      </v-flex>
    </v-layout>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/parameters/reusable/listMixins'
export default {
  data() {
    return {
      columns: [
        { text: 'Sequence', value: 'seqNo' },
        { text: 'Plan No', value: 'planNo' },
        { text: 'Plan Description', value: 'planDesc' },
        { text: 'No Adult Child Discount', value: 'noAdultChildDisc' },
        { text: 'Child Discount Pecentage', value: 'childDiscPct' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' }
      ],
      selectedColumns: ['seqNo', 'planNo', 'planDesc'],
      pagination: {
        sortBy: 'seqNo'
      },
      deletePlan: '',
      promptRemove: false,
      menu: []
    }
  },
  watch: {
    'fetchPlan': function (value) {
      if (value !== false) {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      const apiURI = this.schemeMenu.menu.pkgPlans
      if (apiURI) {
        try {
          const expand = {
            scheme: this.scheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((pkgPlan) => {
              const convertPkgPlan = {
                planNo: pkgPlan.planNo,
                planDesc: pkgPlan.planDesc,
                noAdultChildDisc: pkgPlan.noAdultChildDisc,
                childDiscPct: pkgPlan.childDiscPct,
                effDate: this.formatDate(pkgPlan.effDate),
                expDate: this.formatDate(pkgPlan.expDate),
                seqNo: pkgPlan.seqNo
              }
              this.items.push(convertPkgPlan)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          const { data } = error
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.loading = false
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPlan = data
        this.deletePlan = data.planDesc
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.menu.pkgPlanDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.scheme,
          planNo: this.selectedPlan.planNo,
          planDesc: this.selectedPlan.planDesc,
          noAdultChildDisc: this.selectedPlan.noAdultChildDisc,
          childDiscPct: this.selectedPlan.childDiscPct,
          effDate: this.removeFormatDate(this.selectedPlan.effDate),
          expDate: this.removeFormatDate(this.selectedPlan.expDate),
          seqNo: this.selectedPlan.seqNo
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Scheme')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  props: {
    fetchPlan: {
      type: Boolean,
      default: false
    },
    scheme: {
      type: String,
      default: ''
    }
  },
  mixins: [
    listMixin,
    MessageMixin
  ]
}
</script>

<style>

</style>
